import { ApiProject, ApiSimpleComponent } from "@incendium/api";
import { personalisationService } from "Apis";
import { useProjectSharedState } from "Hooks/useSharedState";

const fetchLanders = async (selectedProject: ApiProject | null) => {
  if (selectedProject) {
    const res =
      await personalisationService.personalisationServiceListLanderComponents({
        projectId: selectedProject.id as number,
      });
    return res.components || [];
  }
  return [];
};
export const useLanderComponents = () => {
  const { state, setState, loading, refetch } = useProjectSharedState<
    ApiSimpleComponent[]
  >("landerComponents", [], fetchLanders);

  return {
    components: state,
    setComponents: setState,
    loading,
    refetch,
  };
};
